import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import downloadIcon from '../assets/img/download.svg';

export default class ChartDownloadMenu extends Component {
  static propTypes = {
    getChart: PropTypes.func,
    chartId: PropTypes.string
  };

  state = { items: [] };

  getChart = () => {
    if (this.props.getChart) return this.props.getChart();
    const box = this.props.chartId && document.getElementById(`${this.props.chartId}-details`);
    return box ? [...Highcharts.charts, ...Highstock.charts].find(chart => chart && chart.renderTo === box) : null;
  };

  handleToggle = isOpen => {
    const chart = isOpen && this.getChart();
    if (!chart) return;
    const exporting = chart.options.exporting || {};
    const definitions = exporting.menuItemDefinitions || {};
    const contextButton = (exporting.buttons && exporting.buttons.contextButton) || {};
    const items = (contextButton.menuItems || [])
      .map(item => (typeof item === 'string' ? definitions[item] : item))
      .filter(item => item && !item.separator && (item.text || item.textKey))
      .map(item => ({ text: item.text || chart.options.lang[item.textKey], onclick: () => item.onclick.call(chart) }));
    this.setState({ items });
  };

  render() {
    return (
      <Dropdown className='chart-download' align='end' onToggle={this.handleToggle}>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="exportTooltip" className="tooltip_dark">
              Export options
            </Tooltip>
          }>
          <Dropdown.Toggle variant='secondary' size='sm' className='btn-action'>
            <img src={downloadIcon} alt="download" />
          </Dropdown.Toggle>
        </OverlayTrigger>
        <Dropdown.Menu>
          {this.state.items.map(item => (
            <Dropdown.Item as='button' key={item.text} onClick={item.onclick}>{item.text}</Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
